<template>
    <div style='min-height: calc(100vh - 176px);' class="flex flex-wrap mt-4">
        <div class="w-full mb-12 px-4">
            <card-table 
                pageTitle="Группа курса" 
                :pageUrl="pageUrl"
                field_key="name"
                path='/admin/course-group/'
                :filedWidth="filedWidth"
                />
        </div>
        <div class="w-full mb-12 px-4">
            <!-- <card-table color="dark" /> -->
        </div>
    </div>
</template>
<script>

import CardTable from "@/components/Cards/CardTableUsers.vue";
import { API_BASE } from '@/const/uri';

export default {
    data() {
        return {
            pageUrl: API_BASE.courseGroup.list,
            filedWidth: {
                name: 40,
                faculty: 50,
            },
        }
    },
    components: {
        CardTable,
    },
};
</script>
